import { request,requestXxy } from "@/utils/request";

// 在线考试
const ksPcApi = {
  // 首页
  getexamList(data) {
    return request({
      method: "POST",
      url: "/api/examManage/onlineExamlist/getexamList",
      data: data
    });
  },
  // 考生信息
  examInfo(data) {
    return request({
      method: "POST",
      url: "/api/doExam/examInfoConfirm/examInfo",
      data: data
    });
  },
  // 取题接口
  getTestInfo(data) {
    return request({
      method: "POST",
      url: "/api/doExam/examInfoConfirm/getTestInfo",
      data: data
    });
  },
  // 难易度取题接口
  getFacilityTestInfo(data) {
    return request({
      method: "POST",
      url: "/api/paperManage_difflevel/getExam/exam/getTestInfo",
      data: data
    });
  },
  // 考试时间
  examTimeGet(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/examTimeGet/examTimeGet",
      data: data
    });
  },
  // 提交试卷 
  submitExamResult(data) {
    return request({
      method: "POST",
      url: "/api/doExam/examInfoConfirm/submitExamResult",
      data: data
    });
  },
  // 查看考试成绩 
  getStudentTestResults(data) {
    return request({
      method: "POST",
      url: "/api/examManage/onlineExamlist/getStudentTestResults",
      data: data
    });
  },
   // 科目列表
   subjectList(data) {
    return request({
      method: "POST",
      url: "/api/ksbao/ksbVideo/subjectList",
      data: data
    });
  },
   // 获取视频分类 appID->科目ID
   getVideoCatalogue(data) {
    return request({
      method: "POST",
      url: "/api/ksbao/ksbVideo/getVideoCatalogue",
      data: data
    });
  },
   // 获取视频章节appEName->科目英文名 bookID->分类的bookID
   videoChapter(data) {
    return request({
      method: "POST",
      url: "/api/ksbao/ksbVideo/getVideoChapter",
      data: data
    });
  },
   // 获取视频播放地址  nodeID->视频章节ID
   getVideoPlayUrl(data) {
    return request({
      method: "POST",
      url: "/api/ksbao/ksbVideo/getVideoPlay",
      data: data
    });
  },
  // 获取练习列表
  onlineTest(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/ykl/onlineTest",
      data: data
    });
  },
  // 获取题库数据 
  getPaper(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/ykl/paper",
      data: data
    });
  },
  // 获取答题记录
  practice_Answer_LIst(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/practice_Answer_LIst",
      data: data
    });
  },
  // 查看是否收藏和笔记
  getNoteCollect(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/examOptionApi/getNoteCollect",
      data: data
    });
  },
  // 提交答案 
  record_practice_log(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/record_practice_log",
      data: data
    });
  },
  testHistory(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/examOptionApi/testHistory",
      data: data
    });
  },
  // 收藏 
  collectApi(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/examOptionApi/collectApi",
      data: data
    });
  },
  // 提交笔记 
  saveNote(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/examOptionApi/saveNote",
      data: data
    });
  },
  // 重新答题 
  delete_pratice_all(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/delete_practice_all",
      data: data
    });
  },
  // 埋点 
  updateExerciseLog(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/ykl/updateExerciseLog",
      data: data
    });
  },
};

export default ksPcApi;
